module.exports = __webpack_public_path__ + "img/Step4.8e7f00e3.png";